import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    component: () => import("@/Domain/Dashboard/DashboardView.vue"),
    meta: { title: "Vue d’ensemble" },
  },
  {
    path: "/cotisations",
    component: () => import("@/Domain/Contribution/ContributionsView.vue"),
    meta: { title: "Cotisations mensuelles" },
  },
  {
    path: "/membres",
    component: () => import("@/Domain/Member/MembersView.vue"),
    meta: { title: "Répertoire des membres" },
  },
  {
    path: "/finances",
    component: () => import("@/Domain/Finance/FinanceView.vue"),
    meta: { title: "Bilans et sorties" },
  },
  {
    path: "/bilan-mensuel",
    component: () => import("@/Domain/Reporting/MonthlyAnnualReportView.vue"),
    meta: { title: "Bilan par mois" },
  },
  {
    path: "/bilan-personnes",
    component: () => import("@/Domain/Reporting/MemberAnnualReportView.vue"),
    meta: { title: "Bilan par personne" },
  },
  {
    path: "/analyse",
    component: () => import("@/Domain/Reporting/AnalyticsView.vue"),
    meta: { title: "Analyse annuelle" },
  },
  {
    path: "/rappel-action-sociale",
    component: () => import("@/Domain/SocialAction/SocialActionView.vue"),
    meta: { title: "Rappel action sociale" },
  },
  {
    path: "/cotisations-ponctuelles",
    component: () =>
      import(
        "@/Domain/OccasionalContribution/OccasionalContributionsView.vue"
      ),
    meta: { title: "Cotisations ponctuelles" },
  },
  {
    path: "/presences/analyse",
    component: () => import("@/Domain/Attendance/AttendanceDashboardView.vue"),
    meta: { title: "Analyse des présences" },
  },
  {
    path: "/presences/suivi",
    component: () => import("@/Domain/Attendance/AttendanceTrackingView.vue"),
    meta: { title: "Suivi des présences" },
  },
  {
    path: "/presences/membres",
    component: () => import("@/Domain/Attendance/AttendanceMembersView.vue"),
    meta: { title: "Membres présence" },
  },
  {
    path: "/presences/rappels",
    component: () => import("@/Domain/Attendance/AttendanceRemindersView.vue"),
    meta: { title: "Rappels présence" },
  },
  {
    path: "/presences/qr-code",
    component: () => import("@/Domain/Attendance/AttendanceQrView.vue"),
    meta: { title: "QR code présence" },
  },
  {
    path: "/presence",
    component: () => import("@/Domain/Attendance/PublicAttendanceView.vue"),
    meta: { title: "Présence", public: true },
  },
  {
    path: "/projets",
    component: () => import("@/Domain/Project/ProjectsView.vue"),
    meta: { title: "Projets" },
  },
  {
    path: "/projets/dara",
    component: () => import("@/Domain/Project/DaraView.vue"),
    meta: { title: "Projet Dara" },
  },
  {
    path: "/projets/vente-viande",
    component: () => import("@/Domain/Project/MeatSalesView.vue"),
    meta: { title: "Projet Vente de viande" },
  },
  {
    path: "/utilisateurs",
    component: () => import("@/Domain/Authentication/UsersView.vue"),
    meta: { title: "Gestion des utilisateurs" },
  },
  {
    path: "/mois",
    component: () => import("@/Domain/Period/PeriodsView.vue"),
    meta: { title: "Gestion des mois" },
  },
  {
    path: "/rappels",
    component: () => import("@/Domain/Reminder/RemindersView.vue"),
    meta: { title: "Rappels WhatsApp" },
  },
  {
    path: "/parametres",
    component: () => import("@/Domain/Settings/SettingsView.vue"),
    meta: { title: "Paramètres" },
  },
];

export default createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});
